import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Form, Input, Space, Typography } from 'antd';

import { getTranslatedString } from 'helpers/i18n';

const { Title } = Typography;

export const MultiInstanceFormFields = () => {
  return (
    <>
      <Title level={5}>
        {getTranslatedString('landlordPortal.applicationTemplate.prototypesDrawer.instances')}
      </Title>

      <Space>
        <Form.Item
          name="min_instances"
          label={getTranslatedString(
            'landlordPortal.applicationTemplate.prototypesDrawer.form.minInstances'
          )}
          requiredMark={'optional'}
          tooltip={{ title: '', icon: <InfoCircleOutlined /> }}
        >
          <Input type="number" min={0} />
        </Form.Item>

        <Form.Item
          name="max_instances"
          label={getTranslatedString(
            'landlordPortal.applicationTemplate.prototypesDrawer.form.maxInstances'
          )}
          requiredMark={'optional'}
          tooltip={{ title: '', icon: <InfoCircleOutlined /> }}
        >
          <Input type="number" min={0} />
        </Form.Item>
      </Space>
    </>
  );
};

export default MultiInstanceFormFields;
